/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import React from 'react';
import DatePickerFooter from '../base/Footer.js';
import '../../_chunks/dep-46de7b2e.js';
import '../../_chunks/dep-e43cf21c.js';
import '../../_chunks/dep-2acfafca.js';
import 'classnames';
import '../../locale/LocalReceiver.js';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../config-provider/ConfigContext.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../button/index.js';
import '../../button/Button.js';
import '../../_chunks/dep-92728dc5.js';
import '../../hooks/useConfig.js';
import '../../hooks/useDomRefCallback.js';
import '../../_util/useRipple.js';
import '../../_util/useAnimation.js';
import '../../_util/setStyle.js';
import '../../_util/dom.js';
import 'raf';
import '../../_chunks/dep-6c5254c6.js';
import '../../_util/easing.js';
import '../../loading/index.js';
import '../../loading/Loading.js';
import '../../common/Portal.js';
import 'react-dom';
import '../../loading/gradient.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '../../_chunks/dep-fd3498b6.js';
import '../../_chunks/dep-ec16db36.js';
import '../../_chunks/dep-036ad2cc.js';
import '../../_chunks/dep-0e15088f.js';
import '../../loading/defaultProps.js';
import '../../loading/plugin.js';
import '../../_util/react-render.js';
import '../../_chunks/dep-e0370ebe.js';
import '../../loading/style/css.js';
import '../../loading/type.js';
import '../../button/defaultProps.js';
import '../../_util/parseTNode.js';
import '../../button/style/css.js';
import '../../button/type.js';

function ExtraContent(props) {
  var presets = props.presets,
    enableTimePicker = props.enableTimePicker,
    presetsPlacement = props.presetsPlacement,
    onPresetClick = props.onPresetClick,
    onConfirmClick = props.onConfirmClick,
    selectedValue = props.selectedValue;
  var showPanelFooter = enableTimePicker || presets;
  return showPanelFooter ? /* @__PURE__ */React.createElement(DatePickerFooter, {
    presets: presets,
    onPresetClick: onPresetClick,
    enableTimePicker: enableTimePicker,
    onConfirmClick: onConfirmClick,
    presetsPlacement: presetsPlacement,
    selectedValue: selectedValue
  }) : null;
}

export { ExtraContent as default };
//# sourceMappingURL=ExtraContent.js.map
